var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotFound2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 201,
    viewBox: "0 0 331 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13507 118.032C3.75175 118.032 1 115.28 1 111.897V105.672C1 102.289 3.75175 99.5371 7.13507 99.5371H323.906C327.289 99.5371 330.041 102.289 330.041 105.672V111.897C330.041 115.28 327.289 118.032 323.906 118.032H7.13507Z",
    stroke: "#838383",
    strokeWidth: 0.799462,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13507 115.156C5.33788 115.156 3.87646 113.694 3.87646 111.897V105.673C3.87646 103.875 5.33788 102.414 7.13507 102.414H16.4792C18.2764 102.414 19.7378 103.875 19.7378 105.673V111.897C19.7378 113.694 18.2764 115.156 16.4792 115.156H7.13507ZM25.0718 115.156C23.2746 115.156 21.8132 113.694 21.8132 111.897V105.673C21.8132 103.875 23.2746 102.414 25.0718 102.414H34.4159C36.2131 102.414 37.6745 103.875 37.6745 105.673V111.897C37.6745 113.694 36.2131 115.156 34.4159 115.156H25.0718ZM43.0085 115.156C41.2113 115.156 39.7499 113.694 39.7499 111.897V105.673C39.7499 103.875 41.2113 102.414 43.0085 102.414H52.3526C54.1498 102.414 55.6112 103.875 55.6112 105.673V111.897C55.6112 113.694 54.1498 115.156 52.3526 115.156H43.0085ZM60.9452 115.156C59.148 115.156 57.6866 113.694 57.6866 111.897V105.673C57.6866 103.875 59.148 102.414 60.9452 102.414H70.2894C72.0865 102.414 73.548 103.875 73.548 105.673V111.897C73.548 113.694 72.0865 115.156 70.2894 115.156H60.9452ZM78.882 115.156C77.0848 115.156 75.6234 113.694 75.6234 111.897V105.673C75.6234 103.875 77.0848 102.414 78.882 102.414H88.2261C90.0233 102.414 91.4847 103.875 91.4847 105.673V111.897C91.4847 113.694 90.0233 115.156 88.2261 115.156H78.882ZM96.8187 115.156C95.0215 115.156 93.5601 113.694 93.5601 111.897V105.673C93.5601 103.875 95.0215 102.414 96.8187 102.414H106.163C107.96 102.414 109.421 103.875 109.421 105.673V111.897C109.421 113.694 107.96 115.156 106.163 115.156H96.8187ZM114.755 115.156C112.958 115.156 111.497 113.694 111.497 111.897V105.673C111.497 103.875 112.958 102.414 114.755 102.414H124.1C125.897 102.414 127.358 103.875 127.358 105.673V111.897C127.358 113.694 125.897 115.156 124.1 115.156H114.755ZM132.692 115.156C130.895 115.156 129.434 113.694 129.434 111.897V105.673C129.434 103.875 130.895 102.414 132.692 102.414H142.036C143.833 102.414 145.295 103.875 145.295 105.673V111.897C145.295 113.694 143.833 115.156 142.036 115.156H132.692ZM150.629 115.156C148.832 115.156 147.37 113.694 147.37 111.897V105.673C147.37 103.875 148.832 102.414 150.629 102.414H159.973C161.77 102.414 163.232 103.875 163.232 105.673V111.897C163.232 113.694 161.77 115.156 159.973 115.156H150.629ZM168.566 115.156C166.768 115.156 165.307 113.694 165.307 111.897V105.673C165.307 103.875 166.768 102.414 168.566 102.414H177.91C179.707 102.414 181.168 103.875 181.168 105.673V111.897C181.168 113.694 179.707 115.156 177.91 115.156H168.566ZM186.504 115.156C184.707 115.156 183.245 113.694 183.245 111.897V105.673C183.245 103.875 184.707 102.414 186.504 102.414H195.848C197.645 102.414 199.107 103.875 199.107 105.673V111.897C199.107 113.694 197.645 115.156 195.848 115.156H186.504ZM204.441 115.156C202.643 115.156 201.182 113.694 201.182 111.897V105.673C201.182 103.875 202.643 102.414 204.441 102.414H213.785C215.582 102.414 217.043 103.875 217.043 105.673V111.897C217.043 113.694 215.582 115.156 213.785 115.156H204.441ZM222.377 115.156C220.58 115.156 219.119 113.694 219.119 111.897V105.673C219.119 103.875 220.58 102.414 222.377 102.414H231.721C233.519 102.414 234.98 103.875 234.98 105.673V111.897C234.98 113.694 233.519 115.156 231.721 115.156H222.377ZM240.314 115.156C238.517 115.156 237.055 113.694 237.055 111.897V105.673C237.055 103.875 238.517 102.414 240.314 102.414H249.658C251.455 102.414 252.917 103.875 252.917 105.673V111.897C252.917 113.694 251.455 115.156 249.658 115.156H240.314Z",
    fill: "#838383",
    stroke: "#838383",
    strokeWidth: 0.799462,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.804 164.124C310.084 164.124 316.797 157.411 316.797 149.131C316.797 140.85 310.084 134.138 301.804 134.138C293.523 134.138 286.811 140.85 286.811 149.131C286.811 157.411 293.523 164.124 301.804 164.124Z",
    stroke: "#838383",
    strokeWidth: 0.799462,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.804 149.131C310.929 150.823 308.794 162.399 308.794 162.399M301.804 149.131C307.832 142.075 316.789 149.71 316.789 149.71M301.804 149.131C298.707 140.383 309.799 136.444 309.799 136.444M301.804 149.131C292.679 147.439 294.813 135.863 294.813 135.863M301.804 149.131C295.776 156.187 286.819 148.552 286.819 148.552M301.804 149.131C304.901 157.879 293.809 161.819 293.809 161.819",
    stroke: "#838383",
    strokeWidth: 0.799462,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.256 198.732L253.248 178.457C253.539 177.744 254.109 177.174 254.822 176.883L275.091 167.896C275.092 167.895 275.093 167.895 275.095 167.894C275.547 167.687 275.767 167.243 275.637 166.613C275.503 165.966 274.997 165.29 274.173 165.005L274.173 165.005L274.163 165.001L225.403 147.556L225.393 147.552L225.383 147.549C224.762 147.312 224.317 147.476 224.084 147.704C223.857 147.928 223.673 148.369 223.915 149.036L223.917 149.041L241.36 197.782C241.687 198.623 242.395 199.135 243.046 199.269C243.641 199.392 244.023 199.203 244.209 198.839L244.256 198.732Z",
    stroke: "#838383",
    strokeWidth: 2.12907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.339 20.7679L160.404 74.1027L160.039 73.9082C161.81 68.4928 163.582 63.0774 165.444 57.3742C164.743 57.4734 164.202 57.4948 163.695 57.6329C153.276 60.4664 142.86 63.3115 132.446 66.1683C125.466 68.094 118.501 70.0801 111.529 72.035C110.949 72.2319 110.327 72.2708 109.727 72.1478L157.764 41.9625L158.052 42.1882C157.275 45.0865 156.497 47.9868 155.615 51.2702L221.144 20.3691L221.339 20.7679Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10222_49444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5203 15.001H88.5203",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.521 30V0",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5202 6.96484C73.0843 8.85418 72.1532 10.5934 70.8226 12.0038C69.4921 13.4142 67.81 14.4449 65.9492 14.9901C65.9492 14.9901 72.5738 17.5264 73.5675 23.6021C73.5675 23.6021 75.129 14.9901 82.3215 14.9901C82.2741 14.9901 75.7536 15.4917 73.5202 6.96484Z",
    fill: "#838383"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10222_49444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.52 35.001H268.52",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.521 50V20",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52 26.9648C253.084 28.8542 252.153 30.5934 250.823 32.0038C249.492 33.4142 247.81 34.4449 245.949 34.9901C245.949 34.9901 252.574 37.5264 253.568 43.6021C253.568 43.6021 255.129 34.9901 262.321 34.9901C262.274 34.9901 255.754 35.4917 253.52 26.9648Z",
    fill: "#838383"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10222_49444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 69H31",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 78V60",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 64.1787C21.7385 65.3123 21.1799 66.3558 20.3816 67.2021C19.5832 68.0483 18.574 68.6668 17.4575 68.9939C17.4575 68.9939 21.4323 70.5156 22.0285 74.161C22.0285 74.161 22.9654 68.9939 27.2809 68.9939C27.2525 68.9939 23.3402 69.2948 22.0001 64.1787Z",
    fill: "#838383"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10222_49444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4797 159H75.4797",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4802 168V150",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4798 154.179C66.2183 155.312 65.6596 156.356 64.8613 157.202C64.063 158.048 63.0537 158.667 61.9373 158.994C61.9373 158.994 65.912 160.516 66.5082 164.161C66.5082 164.161 67.4451 158.994 71.7606 158.994C71.7322 158.994 67.8199 159.295 66.4798 154.179Z",
    fill: "#838383"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10222_49444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.199 141H188.199",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 150V132",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 136.179C178.938 137.312 178.379 138.356 177.581 139.202C176.783 140.048 175.773 140.667 174.657 140.994C174.657 140.994 178.632 142.516 179.228 146.161C179.228 146.161 180.165 140.994 184.48 140.994C184.452 140.994 180.54 141.295 179.2 136.179Z",
    fill: "#838383"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_10222_49444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.199 71H318.199",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.2 80V62",
    stroke: "#838383",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.2 66.1787C308.938 67.3123 308.379 68.3558 307.581 69.2021C306.783 70.0483 305.773 70.6668 304.657 70.9939C304.657 70.9939 308.632 72.5156 309.228 76.161C309.228 76.161 310.165 70.9939 314.48 70.9939C314.452 70.9939 310.54 71.2948 309.2 66.1787Z",
    fill: "#838383"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10222_49444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(58.5203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10222_49444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(238.52 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10222_49444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 60)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10222_49444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(57.4797 150)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10222_49444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(170.199 132)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_10222_49444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(300.199 62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotFound2);
export default __webpack_public_path__ + "static/media/icon-not-found-2.21b13f81e105eb1517a9d444e2c04ed1.svg";
export { ForwardRef as ReactComponent };